module.exports = __webpack_public_path__ + "img/avatar3.c7f444cc.png";